import { useLocalSearchParams } from 'expo-router';

export function useSafeLocalSearchParams<T>() {
  const params = useLocalSearchParams() as T;

  const cleanedParams = {} as T;
  for (const key in params) {
    if (params[key] !== 'undefined') {
      cleanedParams[key] = params[key];
    }
  }

  return cleanedParams;
}
